import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Clock, Users, Calendar } from 'lucide-react';
const scheduleData = [{
  day: 'Monday',
  classes: [{
    time: '4:30 PM',
    program: 'Little Dragons',
    ages: '4-6',
    instructor: 'Master Kim',
    duration: '45 min'
  }, {
    time: '5:15 PM',
    program: 'Youth Program',
    ages: '7-12',
    instructor: 'Master Lee',
    duration: '60 min'
  }, {
    time: '6:30 PM',
    program: 'Teen & Adult',
    ages: '13+',
    instructor: 'Master Kim',
    duration: '60 min'
  }, {
    time: '7:45 PM',
    program: 'Advanced Training',
    ages: 'Black Belts',
    instructor: 'Master Lee',
    duration: '60 min'
  }]
}, {
  day: 'Tuesday',
  classes: [{
    time: '5:00 PM',
    program: 'Little Dragons',
    ages: '4-6',
    instructor: 'Master Lee',
    duration: '45 min'
  }, {
    time: '5:45 PM',
    program: 'Youth Program',
    ages: '7-12',
    instructor: 'Master Kim',
    duration: '60 min'
  }, {
    time: '7:00 PM',
    program: 'Teen & Adult',
    ages: '13+',
    instructor: 'Master Lee',
    duration: '60 min'
  }]
}, {
  day: 'Wednesday',
  classes: [{
    time: '4:30 PM',
    program: 'Little Dragons',
    ages: '4-6',
    instructor: 'Master Kim',
    duration: '45 min'
  }, {
    time: '5:15 PM',
    program: 'Youth Program',
    ages: '7-12',
    instructor: 'Master Lee',
    duration: '60 min'
  }, {
    time: '6:30 PM',
    program: 'Teen & Adult',
    ages: '13+',
    instructor: 'Master Kim',
    duration: '60 min'
  }, {
    time: '7:45 PM',
    program: 'Sparring Class',
    ages: 'All Levels',
    instructor: 'Master Lee',
    duration: '60 min'
  }]
}, {
  day: 'Thursday',
  classes: [{
    time: '5:00 PM',
    program: 'Little Dragons',
    ages: '4-6',
    instructor: 'Master Lee',
    duration: '45 min'
  }, {
    time: '5:45 PM',
    program: 'Youth Program',
    ages: '7-12',
    instructor: 'Master Kim',
    duration: '60 min'
  }, {
    time: '7:00 PM',
    program: 'Teen & Adult',
    ages: '13+',
    instructor: 'Master Lee',
    duration: '60 min'
  }]
}, {
  day: 'Friday',
  classes: [{
    time: '4:30 PM',
    program: 'Little Dragons',
    ages: '4-6',
    instructor: 'Master Kim',
    duration: '45 min'
  }, {
    time: '5:30 PM',
    program: 'Family Class',
    ages: 'All Ages',
    instructor: 'Master Lee & Master Kim',
    duration: '60 min'
  }, {
    time: '6:45 PM',
    program: 'Forms & Techniques',
    ages: 'All Levels',
    instructor: 'Master Kim',
    duration: '60 min'
  }]
}, {
  day: 'Saturday',
  classes: [{
    time: '9:00 AM',
    program: 'Little Dragons',
    ages: '4-6',
    instructor: 'Master Lee',
    duration: '45 min'
  }, {
    time: '10:00 AM',
    program: 'Family Class',
    ages: 'All Ages',
    instructor: 'Master Kim & Master Lee',
    duration: '60 min'
  }, {
    time: '11:15 AM',
    program: 'Open Mat',
    ages: 'All Levels',
    instructor: 'Staff',
    duration: '45 min'
  }]
}];
const programs = ['All Programs', 'Little Dragons', 'Youth Program', 'Teen & Adult', 'Family Class'];
export function SchedulePage() {
  const [selectedProgram, setSelectedProgram] = useState('All Programs');
  const filteredSchedule = scheduleData.map(day => ({
    ...day,
    classes: selectedProgram === 'All Programs' ? day.classes : day.classes.filter(c => c.program === selectedProgram)
  })).filter(day => day.classes.length > 0);
  return <main className="pt-20 pb-20 bg-gray-50" data-id="element-482">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-483">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-484">
          <Calendar className="w-16 h-16 mx-auto mb-6 text-gold" data-id="element-485" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-486">
            Class Schedule
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-487">
            Find the perfect class time for you and your family. All classes are
            taught by certified instructors.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-488">
        {/* Filter */}
        <div className="mb-8" data-id="element-489">
          <Card className="p-6" data-id="element-490">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-491">
              <div data-id="element-492">
                <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-493">
                  Filter by Program
                </h3>
                <p className="text-sm text-gray-600" data-id="element-494">
                  View classes for specific age groups
                </p>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-495">
                {programs.map(program => <button key={program} onClick={() => setSelectedProgram(program)} className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${selectedProgram === program ? 'bg-primary text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-496">
                    {program}
                  </button>)}
              </div>
            </div>
          </Card>
        </div>

        {/* Schedule Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12" data-id="element-497">
          {filteredSchedule.map(day => <Card key={day.day} className="p-6" data-id="element-498">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 pb-3 border-b border-gray-200" data-id="element-499">
                {day.day}
              </h2>
              <div className="space-y-4" data-id="element-500">
                {day.classes.map((classInfo, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-lg bg-gray-50 hover:bg-blue-50 transition-colors" data-id="element-501">
                    <div className="flex-shrink-0" data-id="element-502">
                      <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center" data-id="element-503">
                        <Clock className="w-6 h-6 text-primary" data-id="element-504" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-505">
                      <div className="flex items-start justify-between gap-2 mb-1" data-id="element-506">
                        <h3 className="font-bold text-gray-900" data-id="element-507">
                          {classInfo.program}
                        </h3>
                        <span className="text-sm font-semibold text-primary whitespace-nowrap" data-id="element-508">
                          {classInfo.time}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 mb-2" data-id="element-509">
                        Ages: {classInfo.ages} • {classInfo.duration}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-510">
                        Instructor: {classInfo.instructor}
                      </p>
                    </div>
                  </div>)}
              </div>
            </Card>)}
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-511">
          <Card className="p-6 text-center" data-id="element-512">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-513">
              <Users className="w-6 h-6 text-primary" data-id="element-514" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-515">Small Class Sizes</h3>
            <p className="text-sm text-gray-600" data-id="element-516">
              Maximum 15 students per class for personalized attention
            </p>
          </Card>

          <Card className="p-6 text-center" data-id="element-517">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-518">
              <Calendar className="w-6 h-6 text-accent" data-id="element-519" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-520">
              Flexible Scheduling
            </h3>
            <p className="text-sm text-gray-600" data-id="element-521">
              Multiple class times throughout the week to fit your schedule
            </p>
          </Card>

          <Card className="p-6 text-center" data-id="element-522">
            <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-523">
              <Clock className="w-6 h-6 text-gold" data-id="element-524" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-525">Consistent Times</h3>
            <p className="text-sm text-gray-600" data-id="element-526">
              Same class times each week for easy planning
            </p>
          </Card>
        </div>

        {/* CTA */}
        <Card className="p-8 md:p-12 text-center bg-gradient-to-r from-primary to-primary-dark text-white" data-id="element-527">
          <h2 className="text-3xl font-bold mb-4" data-id="element-528">Ready to Get Started?</h2>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-529">
            Try any class for 4 weeks with our special introductory offer. No
            long-term commitment required.
          </p>
          <Link to="/trial" data-id="element-530">
            <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-531">
              Start Your 4-Week Trial
            </Button>
          </Link>
        </Card>
      </div>
    </main>;
}